<template>
  <div class="location" v-if="isLocatable">
    <span class="zip" v-text="postalCode"></span>
    <span class="city" v-text="city"></span>
  </div>
</template>

<script>
export default {
  name: 'EventLocation',
  props: {
    postalCode: String,
    city: String,
  },
  computed: {
    isLocatable() {
      return this.postalCode && this.city;
    },
  },
};
</script>

<style scoped lang="scss">
.location {
  font-weight: 400;
  .zip {
    padding-right: 0.3em;
  }
}
</style>
